import type { components } from "@/api/schema.gen";

type MarketView = components["schemas"]["MarketView"];

interface Props {
  markets: MarketView[];
  // Probabilità live (mid) per market_id, alimentato dall'orderbook listener.
  mids: Record<string, number>;
}

/** Ticker bar — marquee orizzontale dei top markets. 32px tall. */
export function Ticker({ markets, mids }: Props) {
  const top = markets.slice(0, 12);
  // Duplichiamo la lista per loop continuo (ticker-track usa -50% translate).
  const items = [...top, ...top];

  return (
    <div className="flex h-8 items-center overflow-hidden border-b border-line bg-bg-1 text-[12px]">
      <div className="ticker-track px-4">
        {items.map((m, i) => {
          const p = mids[m.id] ?? 0.5;
          const trendUp = p >= 0.5;
          return (
            <div
              key={`${m.id}-${i}`}
              className="flex shrink-0 items-center gap-2"
            >
              <span
                className="h-1.5 w-1.5 rounded-full"
                style={{ background: trendUp ? "var(--yes)" : "var(--no)" }}
              />
              <span className="max-w-[260px] truncate text-text-2">
                {m.title}
              </span>
              <span className="font-mono text-text">
                {(p * 100).toFixed(1)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
